import React, { useEffect, useState } from "react";
import { Dialog, DialogTitle, Typography, Box, IconButton, } from "@mui/material";
import HistorialPreciosEspeciales from "./HistorialPreciosEspeciales";
import HistorialPreciosLista from "./HistorialPreciosLista";
import HistoryIcon from '@mui/icons-material/History';
import CloseIcon from '@mui/icons-material/Close';
import { alpha } from "@mui/material/styles";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";

export default function DialogHistorialPrecios(props) {
    const [propsNecesarios, setPropsNecesarios] = useState();

    useEffect(()=>{
        setPropsNecesarios({
            id_cliente:props.params.id || null,
            nro_cliente:props?.params?.nro_cliente || null, 
            precio_especial:props?.params?.precio_especial || null, 
            id_empresa:props?.params?.id_empresa || null,
            id_sucursal:props?.params?.id_sucursal || null,
            id_segmento:props?.params?.id_segmento || null,
            productos:props?.params?.id_producto || null
        })
    },[props])
    // console.log(propsNecesarios)

    const palette = {
        primary: "#0f172a",
        accent: "#0ea5e9",
        accentLight: "#38bdf8",
        surface: "#f8fafc",
        surfaceAlt: "#f1f5f9",
        border: "#e2e8f0",
        text: "#1e293b",
        textSecondary: "#64748b",
        white: "#ffffff",
        success: "#10b981",
        warning: "#f59e0b",
    };

    return (
        <Dialog
            open={props.open}
            fullScreen
            onClose={props.handleClose}
            sx={{
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
            }}
        >
            <DialogTitle
                sx={{
                    background: "linear-gradient(135deg, #164e63 0%, #0c3a47 100%)",
                    color: palette.white,
                    py: 0,
                    px: { xs: 2, md: 4 },
                    minHeight: 80,
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    position: "relative",
                }}
            >
                <Box
                    sx={{
                        width: 48,
                        height: 48,
                        borderRadius: 2,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background: alpha(palette.accent, 0.15),
                        backdropFilter: "blur(8px)",
                        border: `1px solid ${alpha(palette.accent, 0.25)}`,
                        flexShrink: 0,
                    }}
                >
                    <HistoryIcon sx={{ fontSize: 26, color: "white" }} />
                </Box>
                <Box sx={{ zIndex: 1, minWidth: 0 }}>
                    <Typography
                        variant="h6"
                        sx={{
                            fontWeight: 800,
                            color: palette.white,
                            lineHeight: 1.2,
                            letterSpacing: "-0.02em",
                            fontSize: { xs: "1rem", md: "1.2rem" },
                        }}
                    >
                        Historial De Precios
                    </Typography>
                    {
                        props.title && (
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 0.3 }}>
                            <PersonOutlineIcon
                                sx={{ fontSize: 15, color: alpha("#fff", 0.5) }}
                            />
                            <Typography
                                variant="body2"
                                noWrap
                                sx={{
                                    color: alpha("#fff", 0.65),
                                    fontSize: 15,
                                    fontWeight: 500,
                                }}
                            >
                                {props.title}
                            </Typography>
                        </Box>
    
                        )
                    }
                </Box>

                <IconButton
                    onClick={props.handleClose}
                    sx={{
                        color: alpha("#fff", 0.7),
                        ml: "auto",
                        zIndex: 1,
                        border: `1px solid ${alpha("#fff", 0.12)}`,
                        borderRadius: 2,
                        width: 40,
                        height: 40,
                        transition: "all 0.2s",
                        "&:hover": {
                            backgroundColor: alpha("#fff", 0.1),
                            color: palette.white,
                            borderColor: alpha("#fff", 0.25),
                        },
                    }}
                >
                    <CloseIcon sx={{ fontSize: 20 }} />
                </IconButton>
            </DialogTitle>
            <Box>
                {
                    propsNecesarios?.precio_especial === 1 ? (
                        <HistorialPreciosEspeciales dataCliente={propsNecesarios} />
                    ) : (
                        <HistorialPreciosLista
                            params={propsNecesarios}
                            palette={palette}
                        />
                    )
                }
            </Box>
        </Dialog>
    )
}